
import { makeRequest } from 'utils/requestLogger';

export default (live_discussion_id, payload) =>
    makeRequest(
        'post',
        `/api/live_discussions/${live_discussion_id}/grade-classroom-students`, payload
    );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/gradeClassroomStudents.js